import { SchoolService } from "@/services/school.service";
import { mapGetters } from "vuex";
import { termList } from "@/assets/js/utils";

export const planningMixin = {
    data() {
        return { 
            plannerArrayFiltered: [],
            termsList: termList(),
        };
    },
    created() {
        this.fetchData();
    },
    computed: {
        ...mapGetters({
            plannerArray: "planningList",
            settings: "settings",
            currentUser: "currentUser",
        }),
        gridRows() {
            return this.settings.planningDisplayLevel === 0
              ? this.currentUser.isSecondaryBased ? 2 : 2
              : (this.settings.planningDisplayLevel + "").split(".")[1]
          },
          gridColumns() {
            return this.currentUser.isSecondaryBased 
            ? new Array(3).fill('')
            : this.termsList.map((t) => t.name)
          },
    },
    methods: {
        findByKey(arr, id) {
            return arr.find(function (item) {
                return item.key === id;
            });
        },
        fetchData() {
            SchoolService.getAll("planning")
                .then(response => this.buildPlannerArray(response.data.data))
                .catch(err => {
                    console.log("Planning mix " + err);
                    this.errored = true;
                })
                .finally(() => (this.loading = false));
        },
        buildPlannerArray(data) {
            var tm;
            this.$store.commit("REFRESH_PLANNING");
            for (tm of this.termsList) {
                for (let yr = 0; yr < this.years.length; yr++) {
        
                    let termData = data.filter(td => { return td.term === tm.key  })
                    var tempUnits = [];
                   
                    if (termData.length > 0) {
                        tempUnits = termData[0].term_data.filter(pd => {  return pd.year_id === this.years[yr].id });
                       
                        if (tempUnits.length > 0) {
                            tempUnits = tempUnits[0].yeargroup_data;
                        }
                        
                    }

                    let planObj = this.createPlannerObj(tm, yr, tempUnits);
                    this.$store.commit("ADD_PLANNING", planObj);
        
                }
                this.plannerArrayFiltered = this.plannerArray

            }
        },
          
        createPlannerObj(termObj, index, units) {
            
            
            this.plannerArrayCount += 1;
            return {
                year: this.years[index].name,
                year_id: this.years[index].id,
                term: termObj.name,
                term_key: termObj.key,
                units: units ? this.parseUnitsOrder(units) : {},
            };
        },

        parseUnitsOrder(units) {
            let results = units.map(obj => ({ ...obj, 
                column: Math.floor(obj.display_box),
                row: Math.floor(this.parseDecimalValue(obj.display_box))
            }))
            return results
        },

        parseDecimalValue(value) {
            let getDecimalVal = value.toString().indexOf(".");
            return value.toString().substring(getDecimalVal+1)
        },

          columnData(planning) {
//            console.log("PLANNING ", JSON.stringify(planning.terms))
            if (this.currentUser.isSecondaryBased) {
                var results = [];
                for (var i = 0; i < 3; i++) {
                    let termData = planning.terms.filter((t) => t.units.find((u) => u.column === i+1))
                   
                    if (termData.length > 0) {
                        results.push(termData)
                      } else {
                        results.push({
                            term_key: planning.terms[0].term_key,
                            year_id: planning.terms[0].year_id,
                            units: []
                        })
                      }
                }

               // console.log("SSSS", JSON.stringify(results.flat()))

              return results.flat()
            } else {
              return planning.terms
            }
          }
    }
};

